import { useEffect, useState } from 'react';
import axios from '../../../axios';
import Loader from '../../../Layout/Loaders/Loader';
import { Modal } from '../../UI';

const ProdCatModal = ({ isOpen, onClose, catSelected }) => {
    const [cat, setCat] = useState({ products: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        if (catSelected && catSelected > 0) {
            axios.get(`api/category-with-products/${catSelected}`)
                .then(res => {
                    setCat(res.data);
                    setLoading(false);
                })
                .catch(e => {
                    console.log(e, 'Error todos los producto');
                    setLoading(false);
                });
        }
    }, [catSelected]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={null}
            size="xl"
            showCloseButton={false}
        >
            {loading ? (
                <div className='h-48 flex items-center justify-center'>
                    <Loader />
                </div>
            ) : (
                <div className="space-y-6">
                    {/* Header del modal */}
                    <div className="border-b border-gray-200 pb-4">
                        <div className="flex items-center justify-between">
                            <div className='flex items-center gap-3'>
                                <div className="w-1 h-8 bg-[#11cdef] rounded-full"></div>
                                <div>
                                    <h4 className="text-lg font-semibold text-gray-900">
                                        {cat?.nombre_categoria}
                                    </h4>
                                    <p className="text-sm text-gray-600">Lista de Productos</p>
                                </div>
                            </div>
                            <button
                                onClick={onClose}
                                className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
                            >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Lista de productos */}
                    <div className='space-y-2 max-h-96 overflow-y-auto pr-2'>
                        {cat.products && cat.products.length > 0 ? (
                            cat.products.map((producto) => (
                                <div
                                    key={producto.id}
                                    className='bg-gray-50 rounded-lg border border-gray-200 p-4 hover:bg-gray-100 transition-colors'
                                >
                                    <div className="flex items-center justify-between flex-wrap gap-2">
                                        <div className="flex items-center gap-2">
                                            <svg className="w-2 h-2 text-[#11cdef]" fill="currentColor" viewBox="0 0 8 8">
                                                <circle cx="4" cy="4" r="4" />
                                            </svg>
                                            <span className="text-sm text-gray-600">Producto</span>
                                            <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                            <span className="text-sm font-semibold text-gray-900">
                                                {producto.nombre_producto}
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <svg className="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            <span className="text-base font-bold text-cyan-600">
                                                ${producto.precio_unidad}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-8 text-gray-500">
                                No hay productos en esta categoría
                            </div>
                        )}
                    </div>

                    {/* Footer del modal */}
                    <div className="border-t border-gray-200 pt-4 flex justify-end">
                        <button
                            onClick={onClose}
                            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors"
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default ProdCatModal;